/* eslint-disable import/exports-last */
/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames'
import commonStyles from '../shared/styles.module.css'
import styles from './UserInfo.module.css'
import { DefaultLink } from '../shared'
import { Icon } from '../../components'

export type UserLoginLinkProps = {
  text: { loginUrl: string; label: string }
  Link?: React.FC<any>
}

function UserLoginLink({ text, Link = DefaultLink }: UserLoginLinkProps) {
  return (
    <div className={styles.login}>
      <Link
        href={text.loginUrl}
        className={classNames(commonStyles.navigationLink, styles.trigger, styles.loginLink)}
        title={text.label}
        aria-label={text.label}
      >
        <Icon name="user" color="fg-content-primary" className={styles.icon} size="400" />
        <span className={styles.label}>{text.label}</span>
      </Link>
    </div>
  )
}

export default UserLoginLink
